














import {Component, Mixins, Prop} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

type Name = 'giro' | 'hometax' | 'popbill' | 'subsidy'

@Component
export default class InstitutionImg extends Mixins(Assets) {
  @Prop({default: '', type: String}) name: Name
  @Prop({default: 30, type: Number}) width: number
}
